import React from 'react';
import { Box, Center, Image, Text } from '@chakra-ui/react';
import loadinggif from "@/assets/sphere.gif";
export class Loading extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        var _a, _b, _c;
        return React.createElement(Box, { textAlign: 'center' },
            React.createElement(Center, null,
                React.createElement(Image, { width: (_b = (_a = this.props.width) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '150' + "px", src: loadinggif })),
            React.createElement(Text, { color: this.props.color ? this.props.color : 'black', mt: '10px', fontWeight: 'bold', fontSize: '18px' }, (_c = this.props.message) !== null && _c !== void 0 ? _c : ''));
    }
}
